/*=========================================================================================
  File Name: getters.js
  Description: Vuex Store - getters
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

// added so later we can keep breakpoint in sync automatically using this config file
// import tailwindConfig from "../../tailwind.config.js"

const getters = {

	// COMPONENT
		// vx-autosuggest
	// starredPages: state => state.navbarSearchAndPinList.data.filter((page) => page.highlightAction),
  windowBreakPoint: state => {

    // This should be same as tailwind. So, it stays in sync with tailwind utility classes
    if (state.windowWidth >= 1200) return "xl"
    else if (state.windowWidth >= 992) return "lg"
    else if (state.windowWidth >= 768) return "md"
    else if (state.windowWidth >= 576) return "sm"
    else return "xs"
  },  
  isAcessoMaster: state => {
    return !(state.AppActiveUser.idVeiculo !== 0) && !(state.AppActiveUser.idGrupoVeiculo !== 0);
  },
  isAcessoIndividual: state => {
      return (state.AppActiveUser.idVeiculo !== 0);
  },
  isAcessoGrupo: state => {
      return (state.AppActiveUser.idGrupoVeiculo !== 0);
  },
  isVersaoPro: state => {
    return ( state.AppActiveUser.versaoProduto === "PRO" || state.AppActiveUser.versaoProduto === "TODAS");
  },
  isVersaoBasic: state => {
      return state.AppActiveUser.versaoProduto === "BASIC";
  },
  isVersaoFast: state => {
    return state.AppActiveUser.versaoProduto === "FAST";
  },
  filtroRoteirizacoes: state => {
    return state.filtrosPesquisa.roteirizacoes;
  },
  filtroControleViagens: state => {
    return state.filtrosPesquisa.controleViagens;
  },
  dadosParaPercurso: state => {
    return state.dadosParaPercurso;
  },
  filtroAutomatizadorRoteirizacao: state => {
    return state.filtrosPesquisa.automatizadorRoteirizacao;
  },
  filtroDespesas: state => {
    return state.filtrosPesquisa.despesas;
  },
  filtroReceitas: state => {
    return state.filtrosPesquisa.receitas;
  },
  filtroPontosInteresse: state => {
    return state.filtrosPesquisa.pontoInteresse;
  },
  filtroEventosMonitriip: state => {
    return state.filtrosPesquisa.eventosMonitriip;
  }, 
  filtroMensagemTeclado: state => {
    return state.filtrosPesquisa.mensagemTeclado;
  }, 
  filtroAgendaEvento: state => {
    return state.filtrosPesquisa.agendaEventos;
  }, 
  filtroCompraCombustivel: state => {
    return state.filtrosPesquisa.comprasCombustivel;
  }, 
  filtroTanqueCombustivel: state => {
    return state.filtrosPesquisa.tanqueCombustivel;
  }, 
  filtroCompraProduto: state => {
    return state.filtrosPesquisa.compraProduto;
  },
  filtroOcorrenciaVeiculo: state => {
    return state.filtrosPesquisa.ocorrenciaVeiculo;
  }, 
  filtroRespostasChecklist: state => {
    return state.filtrosPesquisa.respostasChecklist;
  }, 
  filtroIntegracaoFacchini: state => {
    return state.filtrosPesquisa.integracaoFacchini;
  }, 
  filtroMotorista: state => {
    return state.filtrosPesquisa.motorista;
  }, 
  filtroVeiculosExternos: state => {
    return state.filtrosPesquisa.veiculosExternos;
  }, 
  isExibirMensagemVeiculosDesatualizado: state => {
    return state.exibirMensagemDesatualizado;
  },
  configColunasGrid: state => {
    return state.colunasGrid;
  },
  configColunasGridMapa: state => {
    return state.colunasGridMapa;
  },
  configColunasDashboardTelemetria: state => {
    return state.colunasDashboardTelemetria;
  },
  configMapa: state => {
    return state.configMapa;
  },
  filtroPedidos: state => {
    return state.filtrosPesquisa.pedidos;
  },
  filtroPneus: state => {
    return state.filtrosPesquisa.pneus;
  },
  menuFrotaConfigCards: state => {
    return state.menuFrotaConfigCards;
  },
  filtroLancamentoAfericao: state => {
    return state.filtrosPesquisa.lancamentoAfericao;
  },
}

export default getters
